// extracted by mini-css-extract-plugin
export default {"groupGameTextsVotesContainer":"tIRfEtHLmI3zNCY6XXJk"};